<template>
  <div id='' class='gPageBorder' v-loading='loading'>
   
      
      <el-row>
        
        <el-col :span='4'>
          <p class='gSgLeftBtn'><el-button @click='multiBind' style=''>{{$t('app_mulPush')}} ({{sNum}})</el-button></p>
        </el-col>

        <el-col :span='8'>
          <div style='height:8px;'></div>
        </el-col>

        <el-col :span='4'>
          <div class='gCtrl'>
            
            <!-- <el-select  @change='selectChange' style='' v-model="channelId" clearable :placeholder="$t('app_distributor')">
              <el-option
                v-for="item in channels"
                :key="item.mechanismid"
                :label="item.mechanismname"
                :value="item.mechanismid">
              </el-option>
            </el-select> -->
          
            <MechanismSelector style='' :data="mechanismData"></MechanismSelector>
          </div>
        </el-col>

        <el-col :span='4'>
          <div class='gCtrl'><el-select  @change='selectStChange' style='' v-model="status" clearable :placeholder="$t('app_status')">
            <el-option
              v-for="item in stModel"
              :key="item.vl"
              :label="item.label"
              :value="item.vl">
            </el-option>
          </el-select></div>
        </el-col>

        <el-col :span='4'>
          <div class='gSideCtrl'><el-input :placeholder="$t('app_deviceNo')" v-model='iNo' @keyup.enter.native='srch' icon='search' :on-icon-click='srch'></el-input></div>
        </el-col>

      </el-row>
      

    
    <div id=''>
      <el-table
      class='gTopMg'
      ref="multipleTable"
      :data="tableData"
      border
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          align='center'
          width="80">
        </el-table-column>
        <el-table-column
          align='center'
          prop="terminalNo"
          :label="$t('app_deviceNo')"
          width="">
        </el-table-column>
        <el-table-column
          prop="terminalName"
          align='center'
          :label="$t('app_deviceName')"
          width="">
        </el-table-column>
        <el-table-column
          prop="terminal_status"
          align='center'
          :label="$t('app_status')"
          width="90">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.terminalStatus == 1 " type="success" size="mini">{{$t('app_online')}}</el-tag>
                    <el-tag v-if="scope.row.terminalStatus == 2 " type="danger" size="mini">{{$t('app_offline')}}</el-tag>
                    <el-tag v-if="scope.row.terminalStatus == 0 " type="gray" size="mini">{{$t('app_new')}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align='center'
          prop="mechName"
          :label="$t('app_distributor')"
          width=''>
        </el-table-column>
        <el-table-column
          prop="operate"
          :label="$t('app_operate')"
          align='center'
          width='80'>
          <template slot-scope='scope'>
            <!-- <el-button  type='text' @click='bindOperate(scope.row)'>{{$t('app_push')}}</el-button> -->

            <el-tooltip class="item" effect="dark" :content="$t('app_push')" placement="top">
              <el-button type='text' @click='bindOperate(scope.row)'><i class="fa fa-upload" style=""></i></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class='gPgDiv'>

        <el-pagination
        class='gPg'
        @current-change="pageSelect"
        @size-change="pageSized"
        :current-page="index"
        :page-sizes='$gRows'
        :page-size="row"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>

      </div>
      
    </div>
  </div>
</template>

<style>
   #tbData{margin-top:20px;}
</style>

<script>
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  export default{
    data () {
      var that = this
      return {
        mechanismData: {
          callback (value) {
            that.channelId = value
            that.selectChange(value)
          }
        },
        sNum: 0,
        status: '',
        iNo: '',
        row: this.$gRow,
        selected: [],
        info: '',
        launcherBind: '',
        tableData: [],
        multipleSelection: [],
        channels: [],
        channelId: '',
        loading: 0,
        total: 0,
        index: 1
      }
    },
    components: {MechanismSelector},
    computed: {
      stModel () {
        var app = [
          {label: this.$t('app_online'), vl: '1'},
          {label: this.$t('app_offline'), vl: '2'},
          {label: this.$t('app_new'), vl: '0'}
        ]

        /*if (this.isLauncher) {
          app = [
            {label: this.$t('app_online'), vl: '1'},
            {label: this.$t('app_offline'), vl: '2'}
          ]
        }*/

        return app
      },
      isLauncher () {
        if (this.launcherBind) {
          return true
        } else {
          return false
        }
      }
      /* index () {
        var vl = this.$getWPage('appMarketTerPage')
        // console.log('page', vl)
        return vl
      } */
    },
    methods: {
      pageSelect (index) {
        this.index = index
        if (this.isLauncher) {
          this.getLauncherDevices()
        } else {
          this.getDevices()
        }
        // this.$setWPage('appMarketTerPage', index)
      },
      pageSized (val) {
        this.$gRow = val
        if (this.isLauncher) {
          this.getLauncherDevices()
        } else {
          this.getDevices()
        }
      },
      selectChange (vl) {
        if (this.isLauncher) {
          this.getLauncherDevices()
        } else {
          this.getDevices()
        }
      },
      selectStChange (vl) {
        if (this.isLauncher) {
          this.getLauncherDevices()
        } else {
          this.getDevices()
        }
      },
      srch () {
        if (this.isLauncher) {
          this.getLauncherDevices()
        } else {
          this.getDevices()
        }
      },
      handleSelectionChange (list) {
        this.sNum = list.length
        this.selected = list
      },
      multiBind () {
        // terminal_id
        // console.log(this.selected)
        var ids = ''
        var tNo = ''
        var tmid = ''
        this.selected.forEach((vl) => {
          ids += vl.terminalId + ','
          tNo += vl.terminalNo + ','
          tmid += vl.manufId + ','
        })
        ids = ids.substring(0, ids.length - 1)
        tNo = tNo.substring(0, tNo.length - 1)
        tmid = tmid.substring(0, tmid.length - 1)
        
        if (this.isLauncher) {
          if (!tNo) {
            this.$message(this.$t('app_oneDeviceMust'))
            return
          }
          this.loading = 1
          this.$pushLauncher(this.launcherBind.launcherid, tNo, localStorage.mechanismId, (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.$message.success(this.$t('app_tipViewTask'))
              this.getLauncherDevices()
            } else {
              this.$message.error(res.message)
            }
          }, (error) => {
            this.loading = 0
            this.$message.error(this.$('app_rqsError'))
          }) 

        } else {
          if (!ids && !tNo) {
            this.$message(this.$t('app_oneDeviceMust'))
            return
          }
          
          this.bind(ids, tNo, tmid)
        }
        
      },
      bindOperate (row) {
        // console.log(row, this.info)
        if (this.isLauncher) {
          this.loading = 1
          this.$pushLauncher(this.launcherBind.launcherid, row.terminalNo, localStorage.mechanismId, (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.$message.success(this.$t('app_tipViewTask'))
              this.getLauncherDevices()
            } else {
              this.$message.error(res.message)
            }
          }, (error) => {
            this.loading = 0
            this.$message.error(this.$('app_rqsError'))
          }) 
        } else {
          this.bind(row.terminalId, row.terminalNo, row.manufId)
        }
        
      },
      getChannels () {
        this.$getChannelList(10000, 1,'','','', (res) => {
          if (res.status === 200) {
            this.channels = res.data
            // console.log(this.channels)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      getDevices () {
        // 
        //var channel = this.channelId ? this.channelId : window.localStorage['mechanismId']
        var channel = this.channelId
        var terminalNo = this.iNo ? this.iNo : ''
        var status = this.status ? this.status : ''
        this.loading = 1

        console.log('iifff iddd', this.info)
        var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid

        if (this.$appUrlTag === 0) {
          this.$getDevices(this.index, this.$gRow, channel, terminalNo, status, '', cId,(res) => {
            // console.log('res', res)
            this.loading = 0
            if (res.data) {
              this.total = res.total
              this.tableData = res.data
            }
          }, () => {
            // error
            this.loading = 0
          })
        } else {
          this.$getDevices1(this.index, this.$gRow, channel, terminalNo, status, '', cId,(res) => {
            // console.log('res', res)
            this.loading = 0
            if (res.data) {
              this.total = res.total
              this.tableData = res.data
            }
          }, () => {
            // error
            this.loading = 0
          })
        }
        
      },
      getLauncherDevices () {
        // 
        //var channel = this.channelId ? this.channelId : window.localStorage['mechanismId']
        var channel = this.channelId
        var terminalNo = this.iNo ? this.iNo : ''
        var status = this.status ? this.status : ''
        this.loading = 1
        this.$pushLauncherList(this.index, this.$gRow, channel, terminalNo, status, '', this.launcherBind.launcherid, '', (res) => {
          // console.log('res', res)
          this.loading = 0
          if (res.data) {
            this.total = res.total
            this.tableData = res.data
          }
        }, () => {
          // error
          this.loading = 0
        })
      },
      bind (tId, tNo, tmid) {
        // console.log(this.info)
        var vl = tId ? tId : ''
        this.loading = 1

        var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid

        if (this.$appUrlTag === 0) {
          this.$bindApp('0', vl, cId, (res) => {
            if (res.status === 200) {
              this.$message.success(this.$t('app_tipViewTask'))
            } else {
              this.$message.error(res.message)
            }
            this.loading = 0
          }, () => {
            // error
            this.loading = 0
          })
        } else {
          this.$bindApp1(tmid, tNo, cId, (res) => {
            if (res.status === 200) {
              this.$message.success(this.$t('app_tipViewTask'))
            } else {
              this.$message.error(res.message)
            }
            this.loading = 0
          }, () => {
            // error
            this.loading = 0
          })
        }
        
      }
    },
    mounted () {
      var isLauncher = this.$route.path === '/launch-push/launch-push-ter'
      var obj = this.$getWObj().appBindInfo
      if (!isLauncher) {
        this.info = obj.data
        this.getChannels()
        this.getDevices()
        this.launcherBind = ''
      } else {
        this.launcherBind = this.$getWObj().launcherBind
        this.getLauncherDevices()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// terminalBind.vue?a2e6d74c